import React from 'react';

import './lesson-view__skeleton.scss';

const SkeletonProblem = () => {
    return <div className="lesson-view__skeleton-item lesson-view__skeleton-problem" />;
};

export const Skeleton = () => {
    return (
        <div className="lesson-view__skeleton">
            <div className="lesson-view__skeleton-item lesson-view__skeleton-title" />
            <div className="lesson-view__skeleton-item lesson-view__skeleton-description" />
            <div className="lesson-view__skeleton-item lesson-view__skeleton-meta" />
            <div className="lesson-view__skeleton-item lesson-view__skeleton-buttons" />
            <div className="lesson-view__skeleton-problems">
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
                <SkeletonProblem />
            </div>
        </div>
    );
};

export default Skeleton;
